import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from "../../context/Authcontext";
import { Header } from "../Header";
import { Layout } from "./Layout";
import { Link, useNavigate } from "react-router-dom";
import { Sidebar } from "../Sidebar";
import toast from "react-hot-toast";

export const Changepassword = () => {
  const navigate = useNavigate();
  const { isAuthenticated, changepassword, logout } = useContext(AuthContext);
  const [oldPassword, setoldPassword] = useState("");
  const [newpass, setnewpass] = useState("");
  const [confirm_pass, setconfirm_pass] = useState("");
  const [isSidebar, setSidebar] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const submitform = (e) => {
    e.preventDefault();
    let data = {
      password: oldPassword,
      newPassWord: newpass,
      RePassWord: confirm_pass,
    };
    changepassword(data, function (res) {
      console.log(res.status);
      if (res.status) {
        message(1, res.message);
        logout();
        navigate("/");
      } else {
        message(0, res.message);
      }
    });
  };

  const message = (status, text) => {
    if (status === 1) {
      toast.success(text);
    } else if (status === 0) {
      toast.error(text);
    } else if (status === 2) {
      toast.error(text);
    }
  };

  return (
    <>
      <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
      <Header isSidebar={isSidebar} setSidebar={setSidebar} />
      <div
        _ngcontent-hdd-c80=""
        className=""
        style={{height:'100vh'}}
      >
        <div className="marquee">
          <marquee>
            👉👉🏏WOMEN BIG BASH 2024 PREMIUM MATCH AND FANCY MARKETS ARE
            AVAILABLE. PLAY NOW AND WIN BIG WITH KHELOYAR.🏏.💰GET CASH BONUS ON
            EVERY DEPOSIT 💸..👈👈
          </marquee>
        </div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                <Layout />
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-changepassword _nghost-yqq-c159="">
                    <div
                      _ngcontent-yqq-c159=""
                      className="col-md-4 mx-auto change-pass"
                      style={{    border:" 1px solid #9e82ee"}}
                    >
                      <h4 _ngcontent-yqq-c159="" className="chnage-pass-text">
                        Change Password
                      </h4>
                      <div
                        _ngcontent-yqq-c159=""
                        className="bg-white form-box mx-auto custom-padding"
                      >
                        <form
                          onSubmit={submitform}
                          _ngcontent-yqq-c159=""
                          noValidate=""
                          className="ng-untouched ng-pristine ng-invalid"
                        >
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Current Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                               <span _ngcontent-vug-c116="" class="user_icon"><i _ngcontent-vug-c116="" class="bi bi-lock"></i></span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                formcontrolname="current_pass"
                                autofocus=""
                                onChange={(e) => setoldPassword(e.target.value)}
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Current Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="oldPassword"
                                className="floating-label"
                              >
                                Current Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">New Password</label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                               <span _ngcontent-vug-c116="" class="user_icon"><i _ngcontent-vug-c116="" class="bi bi-lock"></i></span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) => setnewpass(e.target.value)}
                                formcontrolname="new_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="New Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="passInput"
                                className="floating-label"
                              >
                                New Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Confirm Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link _ngcontent-yqq-c159="">
                                <svg
                                  _ngcontent-yqq-c159=""
                                  className="svg-inline--fa fa-eye-slash fa-w-20"
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="eye-slash"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 640 512"
                                  data-fa-i2svg=""
                                >
                                  <path
                                    fill="currentColor"
                                    d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                                  ></path>
                                </svg>
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                              <span _ngcontent-vug-c116="" class="user_icon"><i _ngcontent-vug-c116="" class="bi bi-lock"></i></span>
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) =>
                                  setconfirm_pass(e.target.value)
                                }
                                formcontrolname="confirm_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid"
                                placeholder="Confirm Password"
                                type="password"
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="confirmPassInput"
                                className="floating-label"
                              >
                                Confirm Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-4">
                            <button
                              _ngcontent-yqq-c159=""
                              type="submit"
                              className="login-btn"
                            >
                              {" "}
                              Change Password{" "}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </app-changepassword>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};
